'use client';

import { Drama, X } from 'lucide-react';
import { useMasquerade } from '@/hooks/useMasquerade';
import { END_MASQUERADE_LABEL } from '@/lib/access-control/masquerade-ui';
import { Banner, BANNER_ORDER } from '@/components/shell/banner-stack/BannerStack';

/**
 * Persistent amber banner shown at the top of the viewport while masquerading.
 * Displays the masqueraded role names and an "End Masquerade" button.
 */
export function MasqueradeBanner() {
  const { isActive, roleNames, roleIds, deactivateMasquerade, loading } = useMasquerade();

  if (!isActive) return null;

  const displayNames = roleNames.length > 0
    ? roleNames.join(', ')
    : `${roleIds.length} role${roleIds.length > 1 ? 's' : ''}`;

  return (
    <Banner role="status" order={BANNER_ORDER.masquerade} testId="masquerade-banner" className="bg-amber-950/80 border-b border-amber-500/30 backdrop-blur-sm">
      <div className="flex items-center justify-between px-4 py-2">
        <div className="flex items-center gap-2 text-sm text-amber-200">
          <Drama className="w-4 h-4 text-amber-400 shrink-0" />
          <span>
            <span className="font-medium text-amber-100">Masquerading as:</span>{' '}
            {displayNames}
          </span>
        </div>
        <button
          onClick={() => deactivateMasquerade()}
          disabled={loading}
          className="flex items-center gap-1.5 px-3 py-1 text-xs font-medium text-amber-200 hover:text-white bg-amber-800/50 hover:bg-amber-700/60 rounded-md transition-colors disabled:opacity-50"
        >
          <X className="w-3.5 h-3.5" />
          {END_MASQUERADE_LABEL}
        </button>
      </div>
    </Banner>
  );
}
